import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Aguardando from '../common/template/aguardando';
import { MapLeaflet } from "../common/mapLeaflet/MapLeaflet";
import Cookies from 'js-cookie';
import Select from '../common/form/select';
import SelectDialog from '../common/form/selectDialog';
import SelectNovo from '../common/form/selectNovo';
import SwitchVertical from '../common/form/switchVertical';
import InputPesquisa from '../common/form/inputPesquisa';
import ReportsArquivo from '../reportsArquivo/reportsArquivo';

import { 
	setModoTela, setFiltro, setDestinado, getListaFronteiras, getListaNegociadores, getListaOperacoes, getLista, getListaSolicitacoes, getListaOcorrencias
} from './reportsActions';
import {
	registrarAcesso
} from '../analiseAcesso/analiseAcessoActions';
import {
	getLista as getListaArquivos
} from '../reportsArquivo/reportsArquivoActions'
import {
	salvarFavoritos
} from '../auth/authActions';

class Reports extends Component {

	state = {
		windowHeight: window.innerHeight,
		windowWidth: window.innerWidth,
		linhaSelecionada: null,
		pesquisar: '',
		cardSelecionados: [/*1, 2, 3, 4, 5, 6*/],
		idShippingExpandido: null,
		resumido: true,
		registroModal: null,
		filtrosAbertos: true,
		filtro: {
			apenasNacional: false,
			rumos: [],
			farolAtrasos: [],
			fronteiras: [],
			operacoes: [],
			negociadores: [],
			lote: false,
			classificada: false,
			expressa: false,			
			ocorrenciaAberta: false,
			cavaloEngatado: false,
			somenteCarreta: false,
			semConjunto: false,
			emCD: false,
			semDocumento: false,
			nacional: this.props.usuarioCarregado ? this.props.usuarioCarregado.nacional : false,
			internacional: this.props.usuarioCarregado ? this.props.usuarioCarregado.internacional : false,
			colunasPesquisa:[]
		},
		ordenacao: {
			shipping: 0,
			documentos: 0,
			cavalo: 0,
			carreta: 0,
			lote: 0,
			classificada: 0,
			expressa: 0,
			ocorrencia: 0,
			cliente: 0,
			rota: 0,
			fronteira: 0,
			previsao: 0,
			statusPrevisao: 0,
			km_restante: 0,
			posicao: 0,
			statusPosicao: 0,
			destinado: 0
		}
	}

	componentDidMount() {
		
		document.addEventListener('keydown', this.handleKeyDown);

		window.addEventListener('resize', this.updateTela);

		//Início do registro de Análise Tela
		this.timeEntrouTela = Date.now();
		this.idEntrouTela = setInterval(() => {
			this.props.registrarAcesso('Reports', this.props.location.pathname, Date.now() - this.timeEntrouTela);
			this.timeEntrouTela = Date.now();
		}, 60000);
		//Fim do registro de Análise Tela
	}
	
    componentWillMount() {
		this.props.getListaFronteiras();
		this.props.getListaNegociadores();
		this.props.getListaOperacoes();
        this.props.getLista();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getListaFronteiras();
			this.props.getListaNegociadores();
			this.props.getListaOperacoes();
			this.props.getLista();
		}, 120000)
    }

	componentWillUnmount() {

		document.removeEventListener('keydown', this.handleKeyDown);

		window.removeEventListener('resize', this.updateTela);

		//Início do encerramento de Análise Tela
		clearInterval(this.idEntrouTela);
		this.props.registrarAcesso('Reports', this.props.location.pathname, Date.now() - this.timeEntrouTela);
		//Fim do encerramento de Análise Tela
		
		clearInterval(this.idIntervalAtualizacao);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({ ...this.state, registroModal: null, registroArquivos: null });
		}
	};

	updateTela = () => {

		const height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
		const width = window.visualViewport ? window.visualViewport.width : window.innerWidth;

		this.setState({ windowHeight: height, windowWidth: width });

	}

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.lista()}
                </Content>
            </div>
        )
    }

	filtrar(cards) {

		let filtroOperacoes = (this.state.filtro.operacoes || []).map(operacao => 
			({ id: operacao, nome: this.props.listaOperacoes.filter(opeItem => opeItem.id == operacao).map(opeItem => opeItem.valor).join('') })
		);

		let filtroOperacoesUsuarios = [];
		if (this.props.listaOperacoes.length && this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente && (this.props.usuarioCarregado.id_operacoes || []).length > 0) {
			filtroOperacoesUsuarios = (this.props.usuarioCarregado.id_operacoes || []).map(operacao => 
				({ id: operacao, nome: this.props.listaOperacoes.filter(opeItem => opeItem.codigo == operacao).map(opeItem => opeItem.valor).join('') })
			);
		}
		
		let lista = this.props.lista
			//CARDS
			.filter(item => {
				if (cards) {
					return true;
				}
				if (this.isFavorito(item.shipping_code_id)) {
					return true
				}
				return this.state.cardSelecionados.filter(status => status == item.id_status).length > 0;
			})

			.filter(item => {
				if (this.props.usuarioCarregado && (this.props.usuarioCarregado.placas_cco || []).length > 0) {
					return (this.props.usuarioCarregado.placas_cco || []).filter(placa => placa == item.cavalo).length > 0;
				} else {
					return this.props.usuarioCarregado ? true : false;
				}
			})

			// .filter(item => {
			// 	if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente && (this.props.usuarioCarregado.id_negociadores || []).length > 0) {
			// 		return (this.props.usuarioCarregado.id_negociadores || []).filter(negociador => negociador == item.id_negociador).length > 0;
			// 	} else if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente 
			// 			&& !(this.props.usuarioCarregado.id_negociadores || []).length && !(this.props.usuarioCarregado.cnpjs_remetente_destinatario || []).length) {
			// 		return false;
			// 	} else {
			// 		return true;
			// 	}
			// })

			.filter(item => {
				const usuario = this.props.usuarioCarregado;

				if (!usuario || !usuario.acesso_cliente) {
					return true;
				}

				if ((usuario.id_negociadores || []).length > 0) {
					return usuario.id_negociadores.some(
						negociador => negociador == item.id_negociador
					);
				}

				if (!(usuario.documento_filtro || []).length) {
					return false;
				}

				return true;
			})

			.filter(item => {
				if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente && (this.props.usuarioCarregado.id_operacoes || []).length > 0) {
					return filtroOperacoesUsuarios.filter(operacao => (item.descricao_operacao || '').split(', ').includes(operacao.nome)).length > 0;
				} else {
					return true;
				}
			})		
			
			//Fronteiras do usuário
			.filter(item => {
				if (this.props.usuarioCarregado && (this.props.usuarioCarregado.id_fronteiras || []).length > 0) {
					return (this.props.usuarioCarregado.id_fronteiras || []).filter(fronteira => fronteira == item.id_fronteira_ref).length > 0;
				} else {
					return true;
				}
			})

			.filter(item => {
				if (this.props.usuarioCarregado && (this.props.usuarioCarregado.nome_fronteiras || []).length > 0) {
					return (this.props.usuarioCarregado.nome_fronteiras || []).filter(fronteira => fronteira == item.fronteira).length > 0;
				} else {
					return true;
				}
			})

			.filter(item => {
				//Alianca Crucianelli Piccin Ltda
				if (this.props.usuarioCarregado && this.props.usuarioCarregado.id == 349) {					
					console.log((item.codigo_destinatario || '').trim().split(','));
					
					return (item.codigo_destinatario || '').trim().split(',').includes('52284680000116')
						|| (item.codigo_remetente || '').trim().split(',').includes('52284680000116');
				} else {
					return true;
				}
			})

			// .filter(item => {
			// 	if (this.props.usuarioCarregado && (this.props.usuarioCarregado.cnpjs_remetente_destinatario || []).length > 0) {
			// 		return this.props.usuarioCarregado.cnpjs_remetente_destinatario.filter(cnpj => {
			// 			console.log(item.codigo_remetente, ' - ', item.codigo_destinatario, ' - ');
						
			// 			return (item.codigo_remetente || '').includes(FormatUtils.removerMascara(cnpj))
			// 				|| (item.codigo_destinatario || '').includes(FormatUtils.removerMascara(cnpj));
			// 		}).length > 0;
			// 	} else {
			// 		return true;
			// 	}
			// })

			.filter(item => {
				if (this.props.usuarioCarregado && (this.props.usuarioCarregado.documento_filtro || []).length > 0) {

					return this.props.usuarioCarregado.documento_filtro.some(documento => {

						const documentoFiltro = FormatUtils.removerMascara(documento.documento || '');
						const remetente = FormatUtils.removerMascara(item.codigo_remetente || '');
						const destinatario = FormatUtils.removerMascara(item.codigo_destinatario || '');

						return (
							(documento.remetente && remetente.includes(documentoFiltro))
							|| (documento.destinatario && destinatario.includes(documentoFiltro))
						);
					});

				} else {
					return true;
				}

			})

			//FILTROS SELECT
			.filter(item => {

				if ((this.state.filtro.rumos || []).length && !this.state.filtro.rumos.filter(itemFiltro => itemFiltro == item.rumo).length) {
					return false;
				}
				if ((this.state.filtro.farolAtrasos || []).length 
					&& !this.state.filtro.farolAtrasos.filter(itemFiltro => 
						itemFiltro == 'ADIANTADO' && item.status == 1
						|| itemFiltro == 'ATRASADO' && (item.status == 2 || item.status == 3)
						|| itemFiltro == 'NENHUM' && !item.status
					).length) {
					return false;
				}
				if ((this.state.filtro.fronteiras || []).length && !this.state.filtro.fronteiras.filter(itemFiltro => itemFiltro == item.fronteira).length) {
					return false;
				}
				
				if (filtroOperacoes.length 
					&& !filtroOperacoes.filter(operacao => (item.descricao_operacao || '').split(', ').includes(operacao.nome)).length) {
					return false;
				}
				if ((this.state.filtro.negociadores || []).length && !this.state.filtro.negociadores.filter(itemFiltro => itemFiltro == item.id_negociador).length) {
					return false;
				}

				return true;
			})

			//FILTROS SWITCH
			.filter(item => {
				
				if (this.state.filtro.lote && item.lotes <= 0) {
					return false;
				}
				if (this.state.filtro.classificada && !item.classificada) {
					return false;
				}
				if (this.state.filtro.expressa && !item.expressa) {
					return false;
				}
				if (this.state.filtro.ocorrenciaAberta && !item.ocorrencias_abertas) {
					return false;
				}
				if (this.state.filtro.cavaloEngatado && !item.cavalo) {
					return false;
				}
				if (this.state.filtro.somenteCarreta && (!item.carreta || item.cavalo)) {
					return false;
				}
				if (this.state.filtro.semConjunto && (item.cavalo || item.carreta)) {
					return false;
				}
				if (this.state.filtro.emCD && !item.em_cd) {
					return false;
				}
				if (!this.state.filtro.emCD && item.em_cd) {
					return false;
				}
				if (this.state.filtro.semDocumento && item.qtd_documentos > 0) {
					return false;
				}
				if (!this.state.filtro.nacional || !this.state.filtro.internacional) {
					//Se não tem rumo significa que ainda não foram registrados eventos no shipping
					if (!this.state.filtro.nacional && !this.state.filtro.internacional) {
						return item.rumo == 'INDEFINIDO';
					}
					if (this.state.filtro.nacional && item.rumo != 'NAC') {
						return false;
					}
					if (this.state.filtro.internacional && item.rumo == 'NAC') {
						return false;
					}
				}
				
				return true;

			})
			//FILTRO BUSCA TEXTO
			.filter(item => {

				const colunasPesquisa = this.state.filtro.colunasPesquisa;

				return !(this.state.pesquisar || '').trim()
					|| (this.state.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
					if (pesquisar
						&& !(`
							${!colunasPesquisa.length ? item.shipping_code_id : ''}
							${!colunasPesquisa.length ? (item.documentos || []).filter(documento => documento).join(', ') : ''}
							${!colunasPesquisa.length ? item.negociador : ''}
							${!colunasPesquisa.length ? `${item.cidade_origem_shipping} ${item.cidade_origem_shipping ? '-' : ''} ${item.cidade_destino_shipping}` : ''}
							${!colunasPesquisa.length ? item.fronteira : ''}
							${!colunasPesquisa.length ? item.cavalo : ''}
							${!colunasPesquisa.length ? item.carreta : ''}
							${!colunasPesquisa.length ? item.tipo_cavalo : ''}
							${!colunasPesquisa.length ? item.tipo_carreta : ''}
							${!colunasPesquisa.length ? item.km_restante : ''}
							${!colunasPesquisa.length ? item.veiculo_referencia : ''}
							${!colunasPesquisa.length ? item.documento : ''}

							${((item.id_status == 1/* && item.cavalo*/) || item.id_status == 3 || item.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
								`${item.nome_proxima_previsao} ${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao)}` : ''}
							
							${item.nome_status} 
							${(item.id_status == 2 || item.id_status == 4 || item.id_status == 6) ? //Carregamento, Fronteira e Descarga
								`${item.previsao_diferenca_dias > 0 ? `${item.previsao_diferenca_dias}d` : ''} ${item.previsao_diferenca_horas > 0 ? `${item.previsao_diferenca_horas}h` : ''} ${item.previsao_diferenca_minutos > 0 ? `${item.previsao_diferenca_minutos} min` : ''}` : ''};
								
							${((item.id_status == 1 && item.cavalo) || item.id_status == 3 || item.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
								`${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_real)}` : ''}

							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Sol Carga').length ? item.filtro_solicitacao_carga_id : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Últi Rom').length ? item.filtro_romaneio_atual : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Documento').length ? item.filtro_documento : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Referência').length ? item.filtro_referencia_carga : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Fat. Comercial / NF').length ? item.filtro_fatura : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Motorista').length ? item.filtro_motorista : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Aduanas').length ? item.filtro_aduana : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Remetente').length ? item.filtro_nome_remetente_sol : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Destinatário').length ? item.filtro_nome_destinatario_sol : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Cidade Origem').length ? item.filtro_municipio_origem_sol : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Cidade Destino').length ? item.filtro_municipio_destino_sol : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'País Origem').length ? item.filtro_pais_origem_shipping : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'País Destino').length ? item.filtro_pais_destino_shipping : ''}
							${colunasPesquisa.length && colunasPesquisa.filter(item => item == 'Tipo de Carroceria').length ? item.filtro_tipo_carreta : ''}							
						`).toUpperCase().includes(pesquisar.trim())) {
						return false;
					}

					return true;
				}).length > 0;

			});

			if (this.state.ordenacao.shipping) {
				lista.sort((a, b) => this.state.ordenacao.shipping == 1 
					? (parseInt(a.shipping_code_id) > parseInt(b.shipping_code_id) ? 1 : -1) 
					: (parseInt(a.shipping_code_id) > parseInt(b.shipping_code_id) ? -1 : 1));
			} else if (this.state.ordenacao.documentos) {
				lista.sort((a, b) => this.state.ordenacao.documentos == 1 
					? ((a.documentos || []).filter(documento => documento).join(', ') > (b.documentos || []).filter(documento => documento).join(', ') ? 1 : -1) 
					: ((a.documentos || []).filter(documento => documento).join(', ') > (b.documentos || []).filter(documento => documento).join(', ') ? -1 : 1));
			} else if (this.state.ordenacao.cavalo) {
				lista.sort((a, b) => this.state.ordenacao.cavalo == 1 
					? ((a.cavalo || '') > (b.cavalo || '') ? 1 : -1) 
					: ((a.cavalo || '') > (b.cavalo || '') ? -1 : 1));
			} else if (this.state.ordenacao.carreta) {
				lista.sort((a, b) => this.state.ordenacao.carreta == 1 
					? ((a.carreta || '') > (b.carreta || '') ? 1 : -1) 
					: ((a.carreta || '') > (b.carreta || '') ? -1 : 1));
			} else if (this.state.ordenacao.lote) {
				lista.sort((a, b) => this.state.ordenacao.lote == 1 
					? (a.lotes > b.lotes ? 1 : -1) 
					: (a.lotes > b.lotes ? -1 : 1));
			} else if (this.state.ordenacao.classificada) {
				lista.sort((a, b) => this.state.ordenacao.classificada == 1 
					? (a.classificada > b.classificada ? 1 : -1) 
					: (a.classificada > b.classificada ? -1 : 1));
			} else if (this.state.ordenacao.expressa) {
				lista.sort((a, b) => this.state.ordenacao.expressa == 1 
					? (a.expressa > b.expressa ? 1 : -1) 
					: (a.expressa > b.expressa ? -1 : 1));
			} else if (this.state.ordenacao.ocorrencia) {
				lista.sort((a, b) => this.state.ordenacao.ocorrencia == 1 
					? (a.ocorrencias_abertas > b.ocorrencias_abertas ? 1 : -1) 
					: (a.ocorrencias_abertas > b.ocorrencias_abertas ? -1 : 1));
			} else if (this.state.ordenacao.cliente) {
				lista.sort((a, b) => this.state.ordenacao.cliente == 1 
					? (a.negociador > b.negociador ? 1 : -1) 
					: (a.negociador > b.negociador ? -1 : 1));
			} else if (this.state.ordenacao.rota) {
				lista.sort((a, b) => this.state.ordenacao.rota == 1 
					? (`${a.cidade_origem_shipping} ${a.cidade_origem_shipping ? '-' : ''} ${a.cidade_destino_shipping}` > `${b.cidade_origem_shipping} ${b.cidade_origem_shipping ? '-' : ''} ${b.cidade_destino_shipping}` ? 1 : -1) 
					: (`${a.cidade_origem_shipping} ${a.cidade_origem_shipping ? '-' : ''} ${a.cidade_destino_shipping}` > `${b.cidade_origem_shipping} ${b.cidade_origem_shipping ? '-' : ''} ${b.cidade_destino_shipping}` ? -1 : 1));
			} else if (this.state.ordenacao.fronteira) {
				lista.sort((a, b) => this.state.ordenacao.fronteira == 1 
					? (a.fronteira > b.fronteira ? 1 : -1) 
					: (a.fronteira > b.fronteira ? -1 : 1));
			} else if (this.state.ordenacao.agendamento) {
				lista.sort((a, b) => {
					const itemA = (a.id_status == 1 || a.id_status == 3 || a.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
						`${a.datahora_previsao || ''}`
					: '';
					const itemB = (b.id_status == 1 || b.id_status == 3 || b.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
						`${b.datahora_previsao || ''}`
					: '';
					if (this.state.ordenacao.agendamento == 1) {
						return itemA > itemB ? 1 : -1;
					} else {
						return itemA > itemB ? -1 : 1;
					}
				});
			} else if (this.state.ordenacao.statusPrevisao) {
				lista.sort((a, b) => {
					const itemA = `${a.datahora_status}`;
					const itemB = `${b.datahora_status}`;
					if (this.state.ordenacao.statusPrevisao == 1) {
						return itemA > itemB ? -1 : 1;
					} else {
						return itemA > itemB ? 1 : -1;
					}
				});
			} else if (this.state.ordenacao.previsao) {
				lista.sort((a, b) => {
					const itemA = ((a.id_status == 1/* && item.cavalo*/) || a.id_status == 3 || a.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
						a.datahora_previsao_real
					: '';
					const itemB = ((b.id_status == 1/* && item.cavalo*/) || b.id_status == 3 || b.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
						b.datahora_previsao_real
					: '';
					if (this.state.ordenacao.previsao == 1) {
						return itemA > itemB ? 1 : -1;
					} else {
						return itemA > itemB ? -1 : 1;
					}
				});
			} else if (this.state.ordenacao.posicao) {
				lista.sort((a, b) => this.state.ordenacao.posicao == 1 
					? (a.veiculo_referencia > b.veiculo_referencia ? 1 : -1) 
					: (a.veiculo_referencia > b.veiculo_referencia ? -1 : 1));
			} else if (this.state.ordenacao.statusPosicao) {
				lista.sort((a, b) => this.state.ordenacao.statusPosicao == 1 
				? (a.status > b.status ? 1 : -1) 
				: (a.status > b.status ? -1 : 1));
			} else if (this.state.ordenacao.destinado) {

				lista.sort((a, b) => {

					let destinadoA = 1;
					let destinadoB = 1;
					if (a.id_status == 1) {
						destinadoA = a.statusShipping && a.statusShipping.datahora_destinado_programacao ? 1 : 3;
					} else if (a.id_status == 3) {
						destinadoA = a.statusShipping && a.statusShipping.datahora_destinado_primeiro_transito ? 1 : 3;
					} else if (a.id_status == 5) {
						destinadoA = a.statusShipping && a.statusShipping.datahora_destinado_segundo_transito ? 1 : 3;
					}
					if (b.id_status == 1) {
						destinadoB = b.statusShipping && b.statusShipping.datahora_destinado_programacao ? 1 : 3;
					} else if (b.id_status == 3) {
						destinadoB = b.statusShipping && b.statusShipping.datahora_destinado_primeiro_transito ? 1 : 3;
					} else if (b.id_status == 5) {
						destinadoB = b.statusShipping && b.statusShipping.datahora_destinado_segundo_transito ? 1 : 3;
					}
				
					return this.state.ordenacao.destinado == 1 
						? (destinadoA > destinadoB ? 1 : -1) 
						: (destinadoA > destinadoB ? -1 : 1);
				});
			}

			return lista;
	}

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	lista() {

		let listaInternacional = this.props.lista
			.filter(item => item.rumo != 'NAC')
			.filter(item => {
				if (this.props.usuarioCarregado && (this.props.usuarioCarregado.placas_cco || []).length > 0) {
					return (this.props.usuarioCarregado.placas_cco || []).filter(placa => placa == item.cavalo).length > 0;
				} else {
					return this.props.usuarioCarregado ? true : false;
				}
			})

			.filter(item => {
				if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente && (this.props.usuarioCarregado.id_negociadores || []).length > 0) {
					return (this.props.usuarioCarregado.id_negociadores || []).filter(negociador => negociador == item.id_negociador).length > 0;
				} else if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente 
						&& !(this.props.usuarioCarregado.id_negociadores || []).length && !(this.props.usuarioCarregado.documento_filtro || []).length) {
					return false;
				} else {
					return true;
				}
		});
		if (this.props.lista.length && !listaInternacional.length && !this.state.filtro.apenasNacional) {
			if (this.state.filtro.internacional) {
				this.setState({ 
					...this.state, 
					filtro: { 
						...this.state.filtro, 
						internacional: false,
						apenasNacional: true
					}
				});
			}
		}

		let acessoCliente = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente;

		const qtdFiltrosSelecionados = ((this.state.pesquisar || '').trim() ? 1 : 0)
			+ ((this.state.filtro.colunasPesquisa || []).length ? 1 : 0)
			+ ((this.state.filtro.rumos || []).length ? 1 : 0)
			+ ((this.state.filtro.farolAtrasos || []).length ? 1 : 0)
			+ ((this.state.filtro.fronteiras || []).length ? 1 : 0)
			+ ((this.state.filtro.operacoes || []).length ? 1 : 0)
			+ ((this.state.filtro.negociadores || []).length ? 1 : 0);

		const height = this.state.filtrosAbertos ? (
			this.state.windowWidth < 1120 ? '100%' : (
				this.state.windowWidth < 1514 ? `${this.state.windowHeight - 461}px` : (
					this.state.windowWidth < 1598 ? `${this.state.windowHeight - 428}px` : `${this.state.windowHeight - 345}px`
				)
			)
		) : (
			this.state.windowWidth < 1120 ? '100%' : (
				this.state.windowWidth < 1514 ? `${this.state.windowHeight - 375}px` : (
					this.state.windowWidth < 1598 ? `${this.state.windowHeight - 355}px` : `${this.state.windowHeight - 345}px`
				)
			)
		);

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						{/*<Grid cols='6 6 4 2'>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista();
								}} />
							</Grid>*/}

					</Row>

					{this.state.registroModal ? this.modalShipping() : null}
					
					{this.modalArquivos()}

					<div
						className={`filter-container ${this.state.filtrosAbertos ? 'open' : 'closed'}`}
						style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}	>
						
						{this.state.filtrosAbertos ? (
							<Row alignCenter>
								<InputPesquisa
									minWidth={343}
									cols='12 1 1 1'
									label='Pesquisar'
									value={this.state.pesquisar}
									onChange={value => this.setState({ ...this.state, pesquisar: value })} />
									
								<SelectNovo
									label='Coluna Complementar'
									minWidth={180}
									multi
									options={[
										{ id: 'Aduanas', valor: 'Aduanas' },
										{ id: 'Destinatário', valor: 'Destinatário' },
										{ id: 'Documento', valor: 'Documento' },
										{ id: 'Referência', valor: 'Referência' },
										{ id: 'Fat. Comercial / NF', valor: 'Fat. Comercial / NF' },
										{ id: 'Motorista', valor: 'Motorista' },
										{ id: 'Remetente', valor: 'Remetente' },
										{ id: 'Sol Carga', valor: 'Sol Carga' },
										{ id: 'Últi Rom', valor: 'Últi Rom' },
										{ id: 'Cidade Origem', valor: 'Cidade Origem' },
										{ id: 'País Origem', valor: 'País Origem' },
										{ id: 'Cidade Destino', valor: 'Cidade Destino' },
										{ id: 'País Destino', valor: 'País Destino' },
										{ id: 'Tipo de Carroceria', valor: 'Tipo de Carroceria' }
									]}
									cols='12 1 1 1'
									placeholder='Selecione as colunas'
									multiple={true}
									value={this.state.filtro.colunasPesquisa}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												colunasPesquisa: value.map(item => item.value)
											}
										});
									}} />
							
								{!this.state.filtro.apenasNacional &&
								<SelectNovo
									minWidth={140}
									label='Rumo'
									multi
									options={this.props.listaRumos}
									cols='12 1 1 1'
									placeholder='Selecione'
									multiple={true}
									value={this.state.filtro.rumos}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												rumos: value.map(item => item.value)
											}
										});
									}} />}

								<SelectNovo
									minWidth={170}
									label='Farol Atraso'
									multi
									options={this.props.listaFarolAtraso}
									cols='12 1 1 1'
									placeholder='Selecione'
									multiple={true}
									value={this.state.filtro.farolAtrasos}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												farolAtrasos: value.map(item => item.value)
											}
										});
									}} />
									
								{!this.state.filtro.apenasNacional &&
								<SelectNovo
									minWidth={200}
									label='Fronteira'
									multi
									options={this.props.listaFronteiras
										.filter(item => 
											!(this.props.usuarioCarregado.nome_fronteiras || []).length 
											|| (this.props.usuarioCarregado.nome_fronteiras || []).includes(item.fronteira)
										).map(item => ({ id: item.fronteira, valor: item.fronteira }))}
									cols='12 1 1 1'
									placeholder='Selecione'
									multiple={true}
									value={this.state.filtro.fronteiras}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												fronteiras: value.map(item => item.value)
											}
										});
									}} />}

								{!acessoCliente &&
								<SelectNovo
									minWidth={200}
									label='Operação'
									multi
									options={this.props.listaOperacoes}
									cols='12 1 1 1'
									placeholder='Selecione'
									multiple={true}
									value={this.state.filtro.operacoes}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												operacoes: value.map(item => item.value)
											}
										});
									}} />}

								{!acessoCliente &&
								<SelectNovo
									minWidth={200}
									label='Negociador'
									multi
									options={this.props.listaNegociadores.map(item => ({ id: item.id_negociador, valor: item.negociador }))}
									cols='12 1 1 1'
									placeholder='Selecione'
									multiple={true}
									value={this.state.filtro.negociadores}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												negociadores: value.map(item => item.value)
											}
										});
									}} />}
							</Row>
						) : (
							<Row alignCenter>
								<InputPesquisa
									minWidth={320}
									cols='12 6 4 3'
									label='Pesquisar'
									value={this.state.pesquisar}
									onChange={value => this.setState({ ...this.state, pesquisar: value })} />
									
								<Select
									label='Coluna Complementar'
									minWidth={250}
									multi
									options={[
										{ id: 'Aduanas', valor: 'Aduanas' },
										{ id: 'Destinatário', valor: 'Destinatário' },
										{ id: 'Documento', valor: 'Documento' },
										{ id: 'Referência', valor: 'Referência' },
										{ id: 'Fat. Comercial / NF', valor: 'Fat. Comercial / NF' },
										{ id: 'Motorista', valor: 'Motorista' },
										{ id: 'Remetente', valor: 'Remetente' },
										{ id: 'Sol Carga', valor: 'Sol Carga' },
										{ id: 'Últi Rom', valor: 'Últi Rom' },
										{ id: 'Cidade Origem', valor: 'Cidade Origem' },
										{ id: 'País Origem', valor: 'País Origem' },
										{ id: 'Cidade Destino', valor: 'Cidade Destino' },
										{ id: 'País Destino', valor: 'País Destino' },
										{ id: 'Tipo de Carroceria', valor: 'Tipo de Carroceria' }
									]}
									cols='12 6 4 3'
									placeholder='Selecione as colunas'
									multiple={true}
									value={this.state.filtro.colunasPesquisa}
									onChange={value => {
										this.setState({
											...this.state,
											filtro: {
												...this.state.filtro,
												colunasPesquisa: value.map(item => item.value)
											}
										});
									}} />
							</Row>
						)}

						<div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: 4 }}>

							<div class={`filter-chip ${this.state.filtro.lote ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, lote: !this.state.filtro.lote }})}>
								<i class='fas fa-boxes'></i> Lote
							</div>

							<div class={`filter-chip ${this.state.filtro.classificada ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, classificada: !this.state.filtro.classificada }})}>
								<i class='fas fa-exclamation-triangle'></i> Classificada
							</div>

							<div class={`filter-chip ${this.state.filtro.expressa ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, expressa: !this.state.filtro.expressa }})}>
								<i class='fas fa-shipping-fast'></i> Expressa
							</div>			

							<div class={`filter-chip ${this.state.filtro.ocorrenciaAberta ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, ocorrenciaAberta: !this.state.filtro.ocorrenciaAberta }})}>
								<i class='fas fa-bell'></i> Ocorrência Aberta
							</div>

							<div class={`filter-chip ${this.state.filtro.cavaloEngatado ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, cavaloEngatado: !this.state.filtro.cavaloEngatado }})}>
								<i class='fas fa-link'></i> Cavalo engatado
							</div>

							<div class={`filter-chip ${this.state.filtro.somenteCarreta ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, somenteCarreta: !this.state.filtro.somenteCarreta }})}>
								<i class='fas fa-truck-loading'></i> Somente Carreta
							</div>
							
							<div class={`filter-chip ${this.state.filtro.semConjunto ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, semConjunto: !this.state.filtro.semConjunto }})}>
								<i class='fas fa-unlink'></i> Sem conjunto
							</div>
							
							<div class={`filter-chip ${this.state.filtro.emCD ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, emCD: !this.state.filtro.emCD }})}>
								<i class='fas fa-warehouse'></i> Em CD
							</div>
							
							<div class={`filter-chip ${this.state.filtro.semDocumento ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, semDocumento: !this.state.filtro.semDocumento }})}>
								<i class='fas fa-file'></i> Sem Documento
							</div>
							
							<div class={`filter-chip ${this.state.filtro.nacional ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, nacional: !this.state.filtro.nacional }})}>
								<i class='fas fa-home'></i> Nacional
							</div>

							{!this.state.filtro.apenasNacional &&
							<div class={`filter-chip ${this.state.filtro.internacional ? 'active' : ''}`}
								onClick={() => this.setState({ ...this.state, filtro: { ...this.state.filtro, internacional: !this.state.filtro.internacional }})}>
								<i class='fas fa-globe-americas'></i> Internacional
							</div>}
						</div>
					</div>

					<button
						style={{
							position: 'absolute',
							bottom: -12,
							background: 'white',
							border: 'none',
							cursor: 'pointer',
							fontSize: 13,
							left: '50%',
        					transform: 'translateX(-50%)',
						}}
						onClick={() => this.setState({ filtrosAbertos: !this.state.filtrosAbertos })}>
						{this.state.filtrosAbertos ? 'Ocultar Filtros' : 'Exibir Filtros'}
						<i class={this.state.filtrosAbertos ? 'fas fa-chevron-up' : 'fas fa-chevron-down'} style={{ marginLeft: 4 }}></i>

						{qtdFiltrosSelecionados > 0 && (
							<span class='badge badge-warning'
								style={{
									marginLeft: 8,
									padding: 4,
									width: 20,
									fontSize: 12
								}}
								title='Existem filtros selecionados'>
								{qtdFiltrosSelecionados}
							</span>
						)}
					</button>
				
				</ContentCardHeader>
				<ContentCardBody>

					<div style={{ display: 'flex' } }>
						<div style={{ width: '2%', minWidth: 30, display: 'flex', alignItems: 'center', paddingBottom: 20 }}>
							<SwitchVertical onChange={() => {
								this.setState({ ...this.state, ativado: !this.state.ativado, cardSelecionados: this.state.ativado ? [] : [ 1, 2, 3, 4, 5, 6] });						
							}} />
						</div>
						<div style={{ width: '98%' }}>
							<div class="row" style={{ justifyContent: 'center' }}>
								{[
									{ id: 1, nome: 'Programação' }, { id: 2, nome: 'Carregamento' }, { id: 3, nome: 'Primeiro Trânsito' }, 
									{ id: 4, nome: 'Fronteira' }, { id: 5, nome: 'Segundo Trânsito' }, { id: 6, nome: 'Descarga' }
								].filter(item => this.state.filtro.internacional || (item.id != 3 && item.id != 4)).map(item => {
									
									const backgroundColor = this.state.cardSelecionados.filter(status => status == item.id).length 
										? 'rgb(31, 48, 102, 0.9)' : '#a9b4d6';

									const color = this.state.cardSelecionados.filter(status => status == item.id).length 
										? '#fff' : 'rgb(31, 48, 102, 1)';
									

									let viagensTotal = this.filtrar(true).filter(shipping => shipping.id_status == item.id).length;
									let viagensAtrasadas = this.filtrar(true).filter(shipping => shipping.id_status == item.id && shipping.status > 2).length;
									let vigensOcorrencias = this.filtrar(true).filter(shipping => shipping.id_status == item.id && shipping.ocorrencias_abertas > 0).length;
									let percentual = viagensTotal && viagensAtrasadas ? 100 - ((viagensAtrasadas * 100) / viagensTotal) : 100;

									return (
										<div class="col-xs-6 col-sm-6 col-md-4 col-lg-2" 
											style={{ cursor: 'pointer' }}
											onClick={() => {
												let cardSelecionados = this.state.cardSelecionados.map(status => status);
												if (this.state.cardSelecionados.filter(status => status == item.id).length) {
													cardSelecionados = cardSelecionados.filter(status => status != item.id);
												} else {
													cardSelecionados.push(item.id);
												}
												this.setState({
													...this.state,
													cardSelecionados: cardSelecionados
												});

											}}>
											<div class="small-box" 
												style={{
													backgroundColor: backgroundColor
												}}>
												<div class="inner">
													<h5 style={{ textAlign: 'center', color: color, fontSize: 16 }}>{item.nome}</h5>
													<div class="progress-group">
														<div class="progress progress-sm" style={{ position: 'relative', height: 16 }}>
															{viagensTotal > 0 &&
															<span style={{
																position: 'absolute',
																top: 0,
																left: 0,
																width: '100%',
																height: '100%',
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																fontWeight: 'bold',
																color: '#000'
															}}>
																{percentual.toFixed(0)}%
															</span>}
															{viagensTotal > 0 &&
															<div
																class={`progress-bar bg-${percentual > 80 ? 'success' : (percentual > 50 ? 'warning' : 'danger')}`}
																style={{ width: `${percentual}%` }}
															></div>}

														</div>
													</div>
													<div style={{ display: 'flex', justifyContent: 'center' }}>
														<div style={{ fontWeight: 'bold', color: color }} title={'Total de shippings'}>
															<i class="fas fa-truck-moving" style={{ marginRight: 2 }}></i>{viagensTotal}
														</div>
														<div style={{ fontWeight: 'bold', marginLeft: 8, marginRight: 8, color: color }} title={'Shippings atrasados'}>
															<i class="fas fa-exclamation-circle" style={{ marginRight: 2 }}></i>{viagensAtrasadas}
														</div>
														<div style={{ fontWeight: 'bold', color: color }} title={'Shippings com ocorrência'}>
															<i class="fas fa-bell" style={{ marginRight: 2 }}></i>{vigensOcorrencias}
														</div>
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: height
						}}>
						<Table responsive border striped alturaFixa 
								maxHeight={height}>
							<THead>
								<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { shipping: this.getNovaOrdenacao(this.state.ordenacao.shipping) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Shipping {this.state.ordenacao.shipping == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.shipping == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { documentos: this.getNovaOrdenacao(this.state.ordenacao.documentos) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Documentos {this.state.ordenacao.documentos == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.documentos == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { cavalo: this.getNovaOrdenacao(this.state.ordenacao.cavalo) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Cavalo {this.state.ordenacao.cavalo == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.cavalo == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { carreta: this.getNovaOrdenacao(this.state.ordenacao.carreta) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Carreta {this.state.ordenacao.carreta == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.carreta == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { lote: this.getNovaOrdenacao(this.state.ordenacao.lote) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter><i class='fas fa-boxes' title='Lote'></i> {this.state.ordenacao.lote == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.lote == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { classificada: this.getNovaOrdenacao(this.state.ordenacao.classificada) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter><i class='fas fa-exclamation-triangle' title='Classificada'></i> {this.state.ordenacao.classificada == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.classificada == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { expressa: this.getNovaOrdenacao(this.state.ordenacao.expressa) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter><i class='fas fa-shipping-fast' title='Viagem Expressa'></i> {this.state.ordenacao.expressa == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.expressa == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { ocorrencia: this.getNovaOrdenacao(this.state.ordenacao.ocorrencia) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter><i class='fas fa-bell' title='Ocorrência'></i> {this.state.ordenacao.ocorrencia == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.ocorrencia == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { cliente: this.getNovaOrdenacao(this.state.ordenacao.cliente) }})} 
										sticky width={150} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Cliente {this.state.ordenacao.cliente == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.cliente == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { rota: this.getNovaOrdenacao(this.state.ordenacao.rota) }})} 
										sticky width={150} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Rota {this.state.ordenacao.rota == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.rota == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									{this.state.filtro.internacional &&
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { fronteira: this.getNovaOrdenacao(this.state.ordenacao.fronteira) }})} 
										sticky width={150} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Fronteira {this.state.ordenacao.fronteira == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.fronteira == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>}
									
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { agendamento: this.getNovaOrdenacao(this.state.ordenacao.agendamento) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Agendamento {this.state.ordenacao.agendamento == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.agendamento == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { statusPrevisao: this.getNovaOrdenacao(this.state.ordenacao.statusPrevisao) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Etapa {this.state.ordenacao.statusPrevisao == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.statusPrevisao == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { previsao: this.getNovaOrdenacao(this.state.ordenacao.previsao) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Previsão de Chegada {this.state.ordenacao.previsao == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.previsao == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { posicao: this.getNovaOrdenacao(this.state.ordenacao.posicao) }})}
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Posição {this.state.ordenacao.posicao == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.posicao == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { statusPosicao: this.getNovaOrdenacao(this.state.ordenacao.statusPosicao) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Status {this.state.ordenacao.statusPosicao == 1 ? <i class="fas fa-sort-amount-down-alt" /> : (this.state.ordenacao.statusPosicao == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>
									{!acessoCliente &&
									<Th onClick={() => this.setState({ ...this.state, ordenacao: { destinado: this.getNovaOrdenacao(this.state.ordenacao.destinado) }})} 
										sticky width={10} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Dest. {this.state.ordenacao.destinado == 1 ? <i class="fas fa-sort-amount-down-alt" title='Destinado' /> : (this.state.ordenacao.destinado == 2 ? <i class="fas fa-sort-amount-up" /> : null)}</Th>}
									<Th 
										sticky width={80} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>
										<a href='#'
											title={!this.state.resumido ? 'Mostrar as informações resumidas' : 'Mostrar as informações completas com quebra de linha'}
											style={{ color: '#ffffff', fontSize: 18 }}
											onClick={(event) => {
												event.preventDefault();
												this.setState({
													...this.state,
													resumido: !this.state.resumido
												});
											}} >
											<i class={`${this.state.resumido ? 'fas fa-expand' : 'fas fa-compress'}`} />
										</a>
									</Th>
								</Tr>
							</THead>
							<TBody>
								{this.filtrar().map(item => {

									let listaSolicitacoes = item.shipping_code_id == this.state.idShippingExpandido
										? this.props.listaSolicitacoes.filter(solicitacao => solicitacao.shipping_code_id == this.state.idShippingExpandido)
										: [];

									return (
										<>
											<Tr key={item.shipping_code_id} backgroundColor={'#ffffff'}>
												<Td minWidth={10}  color={'#000'} alignCenter small title={item.shipping_code_id}>{this.isFavorito(item.shipping_code_id) && <i class={'fas fa-star'} />} {item.shipping_code_id}</Td>
												<Td minWidth={10}  color={'#000'} alignCenter small>{(item.documentos || []).filter(documento => documento).join(', ')}</Td>
												<Td minWidth={10}  color={'#000'} alignCenter small>
													{item.cavalo}
													<div style={{ fontSize: 9 }}>
														{item.tipo_cavalo}
													</div>
												</Td>
												<Td minWidth={10}  color={'#000'} alignCenter small>
													{item.carreta}
													<div style={{ fontSize: 9 }}>
														{item.tipo_carreta}
													</div>
												</Td>
												<Td minWidth={10}  color={'#1F3066'} alignCenter small>
													{item.lotes > 1 &&
													<span class='float-right badge bg-secondary' title='Lote' style={{ fontSize: 11 }}>{item.lotes}</span>}
												</Td>
												<Td minWidth={10}  color={'#000'} alignCenter small>
													{item.classificada &&
													<i class='fas fa-exclamation-triangle' title='Classificada'></i>}
												</Td>
												<Td minWidth={10}  color={'#f00'} alignCenter small>
													{item.expressa &&
													<i class='fas fa-shipping-fast' title='Viagem Expressa'></i>}
												</Td>
												<Td minWidth={10}  color={item.ocorrencias_abertas > 0 ? '#f00' : '#000'} alignCenter small>
													{item.ocorrencias_abertas > 0 ? (
														<i class='fas fa-bell' title='Ocorrência aberta'></i>
													) : (item.ocorrencias_finalizadas ? (
														<i class='fas fa-bell' title='Ocorrência Finalizada'></i>
													) : null)}
												</Td>
												<Td minWidth={150} color={'#000'} alignCenter small>{item.negociador}</Td>
												<Td minWidth={150} color={'#000'} alignCenter small noWrap={this.state.resumido} title={`${item.cidade_origem_shipping} ${item.cidade_origem_shipping ? '-' : ''} ${item.cidade_destino_shipping}`}>{item.cidade_origem_shipping} {item.cidade_origem_shipping ? '-' : ''} {item.cidade_destino_shipping}</Td>
												{this.state.filtro.internacional &&
												<Td minWidth={150} color={'#000'} alignCenter small noWrap={this.state.resumido}>{item.fronteira}</Td>}

												{/* AGENDAMENTO */}
												<Td minWidth={100}  color={'#000'} alignCenter small>
													{(item.id_status == 1 || item.id_status == 3 || item.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
														`${item.nome_proxima_previsao}
														\n${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao) || ''}`
													: ''}
												</Td>

												{/* ETAPA */}
												<Td minWidth={100}  color={'#000'} alignCenter small
													title={
														`${item.nome_status || ''}
														\n${item.permanencia_status || ''}`
													}>
													<p style={{ padding: 0, margin: 0 }}>{item.nome_status}</p>
													<p style={{ padding: 0, margin: 0 }}>{item.permanencia_status}</p>
												</Td>

												{/* PREVISÃO CHEGADA */}
												<Td minWidth={100}  color={'#000'} alignCenter small>
													{((item.id_status == 1/* && item.cavalo*/) || item.id_status == 3 || item.id_status == 5) ? //Programação, Primeiro Trânsito e Segundo Trânsito
														DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_real) || ''
													: ''}
												</Td>

												{/* <Td minWidth={50} color={'#000'} alignCenter small noWrap={this.state.resumido}>{parseInt(item.km_restante) > 0 ? `${FormatUtils.formatarValorTela(item.km_restante, 0)} km` : ''}</Td> */}
												<Td minWidth={100} color={'#000'} alignCenter small noWrap={this.state.resumido}>{item.veiculo_referencia}</Td>
												<Td minWidth={10}  color={item.status == 3 ? '#ff0000' : (item.status == 2 ? '#eeff00' : (item.status == 1 ? '#00cf1f' : '#bfbfbf'))} title={'Status'} alignCenter small>
													<i class='fas fa-circle' style={{ fontSize: 18 }}></i>
												</Td>
												{!acessoCliente &&
												<Td minWidth={10}  color={'#000'} alignCenter>
													{item.id_status == 1 &&
													<ButtonTable
														width={26}
														height={26}
														type={'success'}
														icon={item.statusShipping && item.statusShipping.datahora_destinado_programacao 
															? 'fas fa-check' : ''}
														visible={true}
														small
														title={item.statusShipping && item.statusShipping.datahora_destinado_programacao 
															? `Destinado - ${DateFormat.formatarDataHoraSqlParaTela(item.statusShipping.datahora_destinado_programacao)}` : 'Não Destinado'}
														event={() => {
															this.props.setDestinado('PROGRAMACAO', item);

														}} />}
													
													{item.id_status == 3 &&
													<ButtonTable
														width={24}
														height={24}
														type={'success'}
														icon={item.statusShipping && item.statusShipping.datahora_destinado_primeiro_transito 
															? 'fas fa-check' : ''}
														visible={true}
														small
														title={item.statusShipping && item.statusShipping.datahora_destinado_primeiro_transito 
															? `Destinado - ${DateFormat.formatarDataHoraSqlParaTela(item.statusShipping.datahora_destinado_primeiro_transito)}` : 'Não Destinado'}
														event={() => {
															this.props.setDestinado('PRIMEIRO_TRANSITO', item);

														}} />}

													{item.id_status == 5 &&
													<ButtonTable
														width={24}
														height={24}
														type={'success'}
														icon={item.statusShipping && item.statusShipping.datahora_destinado_segundo_transito 
															? 'fas fa-check' : ''}
														visible={true}
														small
														title={item.statusShipping && item.statusShipping.datahora_destinado_segundo_transito 
															? `Destinado - ${DateFormat.formatarDataHoraSqlParaTela(item.statusShipping.datahora_destinado_segundo_transito)}` : 'Não Destinado'}
														event={() => {
															this.props.setDestinado('SEGUNDO_TRANSITO', item);

														}} />}
												</Td>}
												<Td minWidth={80}  color={'#000'} alignCenter>
													<ButtonTable
														type={'primary'}
														icon={'fas fa-eye'}
														visible={true}
														small
														title={'Ver detalhes'}
														event={() => {
															this.setState({
																...this.state,
																registroModal: { ...item }
															});
															
															this.props.getListaSolicitacoes(item.shipping_code_id);
															this.props.getListaOcorrencias(item.shipping_code_id);
															this.props.getListaArquivos(item.shipping_code_id);

														}} />
													<ButtonTable
														type={'primary'}
														icon={this.state.idShippingExpandido == item.shipping_code_id ? 'fas fa-minus' : 'fas fa-plus'}
														visible={true}
														small
														title={'Ver solicitações'}
														event={() => {
															if (this.state.idShippingExpandido != item.shipping_code_id) {
																this.props.getListaSolicitacoes(item.shipping_code_id);
															}
															this.setState({
																...this.state,
																idShippingExpandido: this.state.idShippingExpandido == item.shipping_code_id ? null : item.shipping_code_id
															});
														}} />
												</Td>
											</Tr>
											{listaSolicitacoes.length > 0 && 
											<Tr>
												<Td colspan={this.state.filtro.internacional ? 18 : 17} color={'#01071a'} small>												
													{this.props.listaSolicitacoes.filter((solicitacao, i) => solicitacao.shipping_code_id == this.state.idShippingExpandido)
													.map((solicitacao, i) => {
														
														// let operacao = this.props.listaOperacoes.filter(opItem => (solicitacao.descricao_operacao || '').split(', ').includes(opItem.valor))[0];
														let operacao = this.props.listaOperacoes.filter(opItem => String(solicitacao.operacao_id || '').split(', ').includes(opItem.codigo))[0];
														let documentosComprovantes = operacao ? (operacao.documentos || []).map(doc => doc.nome_documento).join(', ') : '';
														let documentosExcecoes = operacao ? (operacao.excecoes || []).filter(doc => !doc.cnpj_destinatario || FormatUtils.removerMascara(doc.cnpj_destinatario) == solicitacao.codigo_destinatario).map(doc => doc.excecao).join(', ') : '';
														
														return (
															<Row key={solicitacao.solicitacao_carga_id} style={{ borderTop: i == 0 ? null : '2px solid #1F3066' }}>
																<Grid cols='12 6 3 3' style={{ backgroundColor: '#dae0f5', paddingLeft: 10, paddingRight: 10, paddingTop: 4, paddingBottom: 4 }}>
																	<p style={{ margin: 0 }}>Sol Carga: {solicitacao.solicitacao_carga_id}</p>
																	<p style={{ margin: 0 }}>Últi Rom: {solicitacao.romaneio_atual}</p>
																	<p style={{ margin: 0 }}>Documento: {solicitacao.documento}</p>
																	<p style={{ margin: 0 }}>Referência: {solicitacao.observacao}</p>
																</Grid>
																<Grid cols='12 6 3 3' style={{ backgroundColor: '#e6eafa', paddingLeft: 10, paddingRight: 10, paddingTop: 4, paddingBottom: 4 }}>												
																	<p style={{ margin: 0 }}>Fat. Comercial / NF: {solicitacao.fatura}</p>			
																	<p style={{ margin: 0 }}>Peso / Quantidade: {FormatUtils.formatarValorTelaDecimal(solicitacao.documento_peso, 2)} / {FormatUtils.formatarValorTelaDecimal(solicitacao.documento_volumes, 2)}</p>
																	<p style={{ margin: 0 }}>Motorista: {solicitacao.motorista}</p>
																	<p style={{ margin: 0 }}>Aduanas: {solicitacao.aduana}</p>															
																</Grid>
																<Grid  cols='12 6 3 3' style={{ backgroundColor: '#dae0f5', paddingLeft: 10, paddingRight: 10, paddingTop: 4, paddingBottom: 4 }}>															
																	<p style={{ margin: 0 }}>Remetente: {solicitacao.nome_remetente_sol}</p>
																	<p style={{ margin: 0 }}>Origem: {solicitacao.municipio_origem_sol}</p>
																	<p style={{ margin: 0 }}>Destino: {solicitacao.municipio_destino_sol}</p>
																	<p style={{ margin: 0 }}>Previsão de Coleta: {DateFormat.formatarDataHoraSqlParaTela(solicitacao.data_previsao_carga)}</p>
																</Grid>
																<Grid  cols='12 6 3 3' style={{ backgroundColor: '#e6eafa', paddingLeft: 10, paddingRight: 10, paddingTop: 4, paddingBottom: 4 }}>
																	<p style={{ margin: 0 }}>Destinatário: {solicitacao.nome_destinatario_sol}</p>
																	{((solicitacao.id_fronteira_ref && solicitacao.data_liberacao_fronteira) || (!solicitacao.id_fronteira_ref && solicitacao.data_termino_carga)) &&
																	<p style={{ margin: 0 }}>Previsão de Entrega: {DateFormat.formatarDataHoraSqlParaTela(solicitacao.data_previsao_descarga)}</p>}
																	{(item.id_status == 1 || item.id_status == 3 || item.id_status == 5) &&
																	<p style={{ margin: 0 }}>Previsão Real: {DateFormat.formatarDataHoraSqlParaTela(solicitacao.datahora_previsao_real)}</p>}
																	<p style={{ margin: 0 }}>Status: <i class='fas fa-circle' style={{ fontSize: 16, color: item.status == 3 ? '#ff0000' : (item.status == 2 ? '#eeff00' : (item.status == 1 ? '#00cf1f' : '#bfbfbf')) }}></i></p>

																	<p style={{ margin: 0 }}>Comp.: {documentosComprovantes || '-'}</p>
																	<p style={{ margin: 0 }}>
																		Exceção: 
																		{documentosExcecoes &&
																		<i class='fas fa-exclamation-circle' 
																			style={{ color: '#c49b04', fontSize: 16, paddingTop: 4, paddingLeft: 4, paddingRight: 4 }} >
																		</i>}
																		{documentosExcecoes || '-'}
																	</p>
																</Grid>
															</Row>
														);
													})}
												</Td>
											</Tr>}
										</>
									)
								})}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

	controleFavoritos(idShippingCode) {
		let lista = (this.props.favoritos.favoritos_shipping || []);

		if (this.isFavorito(idShippingCode)) {
			lista = lista.filter(item => item != idShippingCode);
		} else {
			lista.push(idShippingCode);
		}

		// lista = lista.filter(item => (this.props.lista || []).filter(shipping => shipping.shipping_code_id == item).length);

		this.props.salvarFavoritos({
			favoritos_shipping: lista
		});
	}

	isFavorito(idShippingCode) {
		return (this.props.favoritos.favoritos_shipping || []).filter(shipping => shipping == idShippingCode).length > 0;
	}
	
	modalShipping() {

		const qtdSolicitacoes = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).length;
		let mostrarColunaSolicitacao = false;
		this.props.listaPrevisoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).map(item => {
			if ((item.solicitacoes || []).filter(sol => sol).length != qtdSolicitacoes) {
				mostrarColunaSolicitacao = true;
			}
		});

		let solicitacao = this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id)[0] || {};

		let placas = [];
		this.props.listaSolicitacoes.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).forEach(item => {
			if (!placas.filter(placa => placa.cavalo == item.cavalo).length) {
				placas.push(item);
			}
		});

		let acessoCliente = this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente;

        return (
			<>
				<div
					className="modal-backdrop fade show"
					onClick={() =>
						this.setState({
							...this.state,
							registroModal: null
						})
					} />

				<div
					className="modal fade show"
					id="modal-xl"
					style={{ display: "block" }}
					aria-modal="true"
					onMouseDown={() =>
						this.setState({
							...this.state,
							registroModal: null
						})
					} >
					<div class='modal-dialog modal-xl'
    					onMouseDown={(e) => e.stopPropagation()}>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>Shipping Code: {this.state.registroModal.shipping_code_id} <i class={this.isFavorito(this.state.registroModal.shipping_code_id) ? 'fas fa-star' : 'far fa-star'} title={this.isFavorito(this.state.registroModal.shipping_code_id) ? 'Remover dos favoritos' : 'Adicionar aos favoritos'} onClick={() => this.controleFavoritos(this.state.registroModal.shipping_code_id)} style={{ marginLeft: 8, cursor: 'pointer' }}></i></h4>
								
								{/*<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close' 
									onClick={() => this.setState({ ...this.state, registroModal: null })}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
								</button>*/}

								<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
									{/* Botão da câmera */}
									{(!acessoCliente && this.props.usuarioCarregado && this.props.usuarioCarregado.arquivo_reports) &&
									<button
										type='button'
										className='close custom-close'
										onClick={() => {
										this.setState({ 
											...this.state, 
											registroModal: null, 
											registroArquivos: { ...this.state.registroModal } 
										})
										}}
										style={{
										padding: 0,
										marginRight: 12,
										display: "flex",
										alignItems: "center",
										background: "transparent",
										border: "none",
										cursor: "pointer",
										color: "#fff"
										}} >
										<i className='fas fa-images' style={{ fontSize: 28 }}></i>
										
										{this.props.listaArquivos.length > 0 && (
										<span style={{ 
											marginLeft: 2, 
											fontSize: 14, 
											fontWeight: 'bold',
											marginTop: -28
										}}>
											{this.props.listaArquivos.length}
										</span>
										)}
									</button>}

									{/* Botão padrão de fechar */}
									<button
										type='button'
										className='close custom-close'
										data-dismiss='modal'
										aria-label='Close'
										style={{
											marginLeft: 4
										}}
										onClick={() => this.setState({ ...this.state, registroModal: null })} >
										<span aria-hidden='true' style={{ color: '#fff', fontSize: 36 }}>×</span>
									</button>
								</div>								
							</div>
							<div class='modal-body' style={{ height: this.state.windowHeight * 0.8, overflowY: 'scroll' }}>

								<h6>Eventos</h6>

								<Table responsive>
									<THead>
										<Tr>
											<Th width={200} alignLeft>Evento</Th>
											<Th width={300} alignCenter>Referência</Th>
											<Th width={100} alignCenter>Previsão</Th>
											<Th width={100} alignCenter>Realizado</Th>
										</Tr>
									</THead>
									<TBody>
										{this.props.listaPrevisoesEventos.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id)
										.filter(item => {
											if (solicitacao.pais_origem_shipping == 'Brasil' && solicitacao.pais_destino_shipping == 'Brasil') {
												return item.nacional;
											} else {
												return true;
											}
										}).map(item => {
											return (
												<Tr key={item.solicitacoes}>
													<Td width={200} alignLeft small>{item.nome || ''}</Td>
													<Td width={300} alignCenter small>{item.referencia || ''}</Td>
													<Td width={100} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao)}</Td>
													<Td width={100} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_realizado)}</Td>
												</Tr>
											);
										})}
									</TBody>
								</Table>

								<div style={{ width: '100%', height: 2, backgroundColor: '#1F3066', marginTop: 12, marginBottom: 12 }}></div>
								
								<h6>Ocorrências</h6>

								<Table responsive>
									<THead>
										<Tr>
											<Th alignCenter>Tipo</Th>
											<Th alignCenter>Responsável</Th>
											<Th alignCenter>Início</Th>
											<Th alignCenter>Fim</Th>
											<Th alignCenter>Descrição</Th>
											<Th alignCenter>Usuário</Th>
										</Tr>
									</THead>
									<TBody>
										{this.props.listaOcorrencias.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id).map(item => (
											<Tr key={item.id_ocorrencia}>
												<Td alignCenter small>{item.descricao_tipo_ocorrencia || ''}</Td>
												<Td alignCenter small>{item.responsabilidade == 0 ? 'Cliente' : 'Letsara'}</Td>
												<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.data_inicio)}</Td>
												<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.data_termino)}</Td>
												<Td alignCenter small>{item.comentario || ''}</Td>
												<Td alignCenter small>{item.usuario_inclusao || ''}</Td>
											</Tr>
										))}
									</TBody>
								</Table>

								<div style={{ width: '100%', height: 2, backgroundColor: '#1F3066', marginTop: 12, marginBottom: 12 }}></div>

								<h6>Placas</h6>

								<Table responsive>
									<THead>
										<Tr>
											<Th alignCenter>Cavalo</Th>
											<Th alignCenter>Carreta</Th>
											<Th alignCenter>Carroceria</Th>
											<Th alignCenter>Motorista</Th>
											<Th alignCenter>Local</Th>
											<Th alignCenter>Latitude/Longitude</Th>
											<Th alignCenter>Status</Th>
										</Tr>
									</THead>
									<TBody>
										{placas.map(item => (
											<Tr key={item.solicitacao_carga_id}>
												<Td alignCenter small>{item.cavalo || ''}</Td>
												<Td alignCenter small>{item.carreta || ''}</Td>
												<Td alignCenter small>{this.state.registroModal.tipo_carreta || ''}</Td>
												<Td alignCenter small>{item.motorista || ''}</Td>
												<Td alignCenter small>{item.veiculo_referencia || ''}</Td>
												<Td alignCenter small>
													{(item.veiculo_latitude && item.veiculo_longitude) &&
													<a target='blank' href={`https://www.google.com/maps/place/${item.veiculo_latitude},${item.veiculo_longitude}`}>
														{item.veiculo_latitude}, {item.veiculo_longitude}
													</a>}
												</Td>
												<Td alignCenter small>{item.veiculo_status || ''}</Td>
											</Tr>
										))}
									</TBody>
								</Table>

								<Grid cols="12 12 12 12">
									<div style={{ width: "100%", height: 500 }}>
										<MapLeaflet
											coordenadas={placas.filter(item => item.shipping_code_id == this.state.registroModal.shipping_code_id && item.veiculo_latitude && item.veiculo_longitude)
												.map(item => ({
													id: item.solicitacao_carga_id,
													titulo: item.cavalo,
													latitude: item.veiculo_latitude,
													longitude: item.veiculo_longitude,
													direcao: this.state.registroModal.rumo == 'RS' ? 'S' : 'N'
												}))}
											zoom={4}
											latitude={'-28.381875'}
											longitude={'-53.937355'}
											onChange={(coordenadas) => {
											}}
										/>
									</div>
								</Grid>

							</div>
							{/*<div class='modal-footer justify-content-between'>
								<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
								<button type='button' class='btn btn-primary'
									onClick={() => this.setState({ ...this.state, registroModal: null })}>Fechar</button>
							</div>*/}
						</div>
					</div>
				</div>
			</>
        );
    }

	modalArquivos() {

		if (!this.state.registroArquivos) {
			return;
		}

        return (
			<>
				<div
					className="modal-backdrop fade show"
					onClick={() =>
						this.setState({
							...this.state,
							registroArquivos: null
						})
					} />

				<div
					className="modal fade show"
					id="modal-xl"
					style={{ display: "block" }}
					aria-modal="true"
					onMouseDown={() =>
						this.setState({
							...this.state,
							registroArquivos: null
						})
					} >
					<div class='modal-dialog modal-xl'
    					onMouseDown={(e) => e.stopPropagation()}>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>Shipping Code: {this.state.registroArquivos.shipping_code_id}</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close' 
									onClick={() => this.setState({ ...this.state, registroArquivos: null })}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{ height: this.state.windowHeight * 0.8, overflowY: 'scroll', padding: 2 }}>
								<ReportsArquivo 
									shipping={this.state.registroArquivos.shipping_code_id}
									solicitacao={this.state.registroArquivos.solicitacao_carga_id} />
							</div>
						</div>
					</div>
				</div>
			</>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	favoritos: state.auth.favoritos,
	modoTela: state.reports.modoTela,
	aguardando: state.reports.aguardando,
	lista: state.reports.lista.map(item => {
		if (state.auth.usuario && state.auth.usuario.id == 214) { //Demonstração
			return {
				...item,
				negociador: 'DEMONSTRAÇÃO',
				nome_remetente_sol: 'DEMONSTRAÇÃO',
				nome_destinatario_sol: 'DEMONSTRAÇÃO',
				veiculo_referencia: 'DEMONSTRAÇÃO'
			}
		} else {
			return item;
		}
	}),
	datahora_ultima_atualizacao_datalake: state.reports.datahora_ultima_atualizacao_datalake,
	listaFronteiras: state.reports.listaFronteiras,
	listaNegociadores: state.reports.listaNegociadores,
	listaRumos: state.reports.listaRumos,
	listaFarolAtraso: state.reports.listaFarolAtraso,
	listaOcorrencias: state.reports.listaOcorrencias,
	listaSolicitacoes: state.reports.listaSolicitacoes.map(item => {
		if (state.auth.usuario && state.auth.usuario.id == 214) { //Demonstração
			return {
				...item,
				negociador: 'DEMONSTRAÇÃO',
				nome_remetente_sol: 'DEMONSTRAÇÃO',
				nome_destinatario_sol: 'DEMONSTRAÇÃO',
				veiculo_referencia: 'DEMONSTRAÇÃO',
				observacao: 'DEMONSTRAÇÃO'
			}
		} else {
			return item;
		}
	}),
	listaPrevisoes: state.reports.listaPrevisoes,
	listaEventos: state.reports.listaEventos,
	listaPrevisoesEventos: state.reports.listaPrevisoesEventos.map(item => {
		if (state.auth.usuario && state.auth.usuario.id == 214) { //Demonstração
			return {
				...item,
				referencia: 'DEMONSTRAÇÃO',
				observacao: 'DEMONSTRAÇÃO'
			}
		} else {
			return item;
		}
	}),
	listaOperacoes: state.reports.listaOperacoes,
	filtro: state.reports.filtro,
	listaArquivos: state.reportsArquivo.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, setDestinado, getListaFronteiras, getListaNegociadores, getListaOperacoes, getLista, getListaSolicitacoes, getListaOcorrencias,
	registrarAcesso, getListaArquivos,
	salvarFavoritos
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Reports);
